import styled from 'styled-components';
import StyleGuide from 'src/style-guide';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

export const ErrorModalContainer = styled(StyleGuide.DefaultModal)`
  @media ${DEVICE.MOBILE_PORTRAIT} {
    max-width: calc(100vw - 48px);
  }
`;

export const Button = styled(StyleGuide.Button)``;
